import { render, staticRenderFns } from "./RegistrationProfile.vue?vue&type=template&id=bd5f96b6&scoped=true&"
import script from "./RegistrationProfile.vue?vue&type=script&lang=js&"
export * from "./RegistrationProfile.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationProfile.vue?vue&type=style&index=0&id=bd5f96b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5f96b6",
  null
  
)

export default component.exports